module.exports = __webpack_public_path__ + "img/18.315e9ad8.jpg";